import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export interface UpdateConfigProductRequest {
  type: PartnerType;
  createLink: boolean;
  color?: string;
  subtitle?: string;
  label?: string;
}

export async function updateConfigProduct(params: UpdateConfigProductRequest) {
  const { data } = await httpClient.patch<{ success: boolean }>(
    `/config/product`,
    params,
  );
  return data;
}
